import { Api } from "../axios-config";

export interface ICronJob {
	id: string;
	name: string;
	handler: string;
	schedule: string;
	enabled: boolean;
	paused?: boolean;
	payload?: Record<string, unknown>;
	lastRun?: string | null;
	nextRun?: string | null;
	status?: string;
}

const getAll = async (): Promise<ICronJob[] | Error> => {
	try {
		const { data } = await Api().get("/v2/cron");
		return Array.isArray(data) ? data : data?.data ?? [];
	} catch (error) {
		return new Error((error as { message: string }).message || "Erro ao listar fila.");
	}
};

const getHandlers = async (): Promise<string[] | Error> => {
	try {
		const { data } = await Api().get("/v2/cron/handlers");
		return Array.isArray(data) ? data : data?.data ?? [];
	} catch (error) {
		return new Error((error as { message: string }).message || "Erro ao listar handlers.");
	}
};

const getById = async (cronId: string): Promise<ICronJob | Error> => {
	try {
		const { data } = await Api().get(`/v2/cron/${cronId}`);
		return data;
	} catch (error) {
		return new Error((error as { message: string }).message || "Erro ao buscar cron.");
	}
};

const run = async (cronId: string): Promise<void | Error> => {
	try {
		await Api().post(`/v2/cron/${cronId}/run`);
	} catch (error) {
		return new Error((error as { message: string }).message || "Erro ao executar cron.");
	}
};

const enable = async (cronId: string): Promise<void | Error> => {
	try {
		await Api().post(`/v2/cron/${cronId}/enable`);
	} catch (error) {
		return new Error((error as { message: string }).message || "Erro ao habilitar cron.");
	}
};

const disable = async (cronId: string): Promise<void | Error> => {
	try {
		await Api().post(`/v2/cron/${cronId}/disable`);
	} catch (error) {
		return new Error((error as { message: string }).message || "Erro ao desabilitar cron.");
	}
};

const pause = async (cronId: string): Promise<void | Error> => {
	try {
		await Api().post(`/v2/cron/${cronId}/pause`);
	} catch (error) {
		return new Error((error as { message: string }).message || "Erro ao pausar cron.");
	}
};

const reload = async (cronId: string): Promise<void | Error> => {
	try {
		await Api().post(`/v2/cron/${cronId}/reload`);
	} catch (error) {
		return new Error((error as { message: string }).message || "Erro ao recarregar cron.");
	}
};

const reloadAll = async (): Promise<void | Error> => {
	try {
		await Api().post("/v2/cron/reload-all");
	} catch (error) {
		return new Error((error as { message: string }).message || "Erro ao recarregar todos os crons.");
	}
};

const pauseAll = async (): Promise<void | Error> => {
	try {
		await Api().post("/v2/cron/pause-all");
	} catch (error) {
		return new Error((error as { message: string }).message || "Erro ao pausar todos os crons.");
	}
};

const stopAll = async (): Promise<void | Error> => {
	try {
		await Api().post("/v2/cron/stop-all");
	} catch (error) {
		return new Error((error as { message: string }).message || "Erro ao parar todos os crons.");
	}
};

const remove = async (cronId: string): Promise<void | Error> => {
	try {
		await Api().delete(`/v2/cron/${cronId}`);
	} catch (error) {
		return new Error((error as { message: string }).message || "Erro ao remover cron.");
	}
};

export const IntegratorService = {
	getAll,
	getHandlers,
	getById,
	run,
	enable,
	disable,
	pause,
	reload,
	reloadAll,
	pauseAll,
	stopAll,
	remove,
};
